/**
 * App环境预设
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import clientStore from 'store'
import storeExpirePlugin from 'store/plugins/expire'
import moment from 'moment'

Vue.use(VueRouter)
Vue.use(Vuex)

const { mapMutations, mapGetters, mapActions, mapState, createNamespacedHelpers } = Vuex
clientStore.addPlugin(storeExpirePlugin)

// Gobal error handler
window.addEventListener('error', function () {
  if (window.console && window.console.error) {
    window.console.error('Global error', arguments)
  }
})

moment.locale('zh-cn', {
  relativeTime: {
    future: '%s',
    past: '%s前',
    s: '1秒',
    m: '一分钟',
    mm: '%d分钟',
    h: '一小时',
    hh: '%d小时',
    d: '一天',
    dd: '%d天',
    M: '一个月',
    MM: '%d个月',
    y: '一年',
    yy: '%d年'
  }
})

// 设置app命名空间占用
export {
  Vue,
  VueRouter,
  Vuex,
  mapMutations,
  mapGetters,
  mapActions,
  mapState,
  createNamespacedHelpers,
  clientStore
}
